import * as React from 'react';
import { Helmet } from 'react-helmet-async';

const TrustBoxScript = () => {
    return (
        <Helmet>
            <script
                async
                src="//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"
                type="text/javascript"
            />
        </Helmet>
    );
};

export default TrustBoxScript;
